import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import { GLOBAL_STATE, STUDENT_PAYMENTS_PRINCIPAL } from '../constants/actionTypes'

const Selectors = (state: RootState) => prop(GLOBAL_STATE, state)

export const paymentsPrincipalSelector = createSelector(Selectors, prop(STUDENT_PAYMENTS_PRINCIPAL))
